var BldBlimp = new Class({
	Implements: [Events, Options],
	options: {
		cls: 'w_bldblimp'
	},

	initialize: function(element, options){
		this.setOptions(options);

		this.element = this.blimp = element;
		this._element = element._element;

		if(this._element)
			this.build();
	},

	build: function(){
		var cls = this.cls = this.options.cls;
		var fcls = this.fcls = '.'+cls;

		this.counter = 0;
		this._contents = [];

		this.add_rater();
		this.add_tips();

		this._blimp_content = this.blimp._element.getElement(fcls+'_popup_content');
		this._blimp_content.empty();

		var _nav = this._element.getElement(fcls + '_popup_nav');

		if(_nav){
			var _tabs = _nav.getElements('a');

			_tabs.each(function(_el){
				_el.addEvent('click', function(e){
					if(e && e.stop) e.stop();

					if(!_el.hasClass('inactive')){
						_el.setAttribute('data-id', _el.getAttribute('data-id') || ++this.counter);
						this.handle_blimp_calls(_el);
					}
				}.bind(this));

				_el.getParent('.main_item').addEvent('click', function(e){
					if(e && e.stop) e.stop();

					_el.fireEvent('click');
				});
			}.bind(this));

			if(_tabs.length == 1){
				_nav.hide();
			}

			_tabs[0].fireEvent('click');

			this._element.fireEvent('click:relay(' + fcls + '_popup_nav a)');
		}

		this._element.addEvents({
			'click:relay(tr)': function(e, _el){
				var href = _el.getAttribute('data-href');
				if(href && href != ''){
					window.location = href;
				}
			}
		});
	},

	add_rater: function(){
		var _indicators = this._element.getElements('.indicator');

		if(_indicators && _indicators.length != 0){
			new Rater(_indicators,	{
				'max_size': _indicators[0].getSize().x,
				'property': 'data-value',
				'size': 'absolute',
				'animate': true,
				'type': 'horizontal',
				'duration': 500,
				'equal_speed': false,
				'transition': Fx.Transitions.linear
			});
		}
	},

	add_tips: function(){
		var _tipped_elements = [];

		var _tips = this.blimp._element.getElements('._tip');

		_tips.each(function(_tip) {
			if (_tip.getAttribute('data-tip').trim() != '') {
				_tipped_elements.push(_tip);

				//	can be usefull to inactivate elements with no availabilities
				// if(_tip.getAttribute('data-tip').replace(/[\D, 0]/g, '' ) == ''){
				//	 _tip.addClass('inactive');
				// }
			}
		});

		if (_tipped_elements.length > 0) {
			new Tips(_tipped_elements, {
				className: this.cls+'_tips',
				title: function(_element) {
					return null;
				},
				text: function(_element) {
					return _element.getAttribute('data-tip');
				}.bind(this),
				fixed: true,
				offset: {
					x: 20,
					y: 20
				},
				windowPadding:{
					x: 0,
					y: -100
				}
			});
		}
	},

	handle_blimp_calls: function(_element){
		if (this._active_blimp_a === _element) { return; }

		if (this._active_blimp_a) {
			this._active_blimp_a.getParent('.main_item').removeClass('_active');
		}

		this._active_blimp_a = _element;
		_element.getParent('.main_item').addClass('_active');

		this._blimp_content.addClass('_loading');

		if(this._active_content){
			this._active_content.hide();
		}

		if(!this._contents[_element.getAttribute('data-id').toInt()-1]){
			var rpc =  (_element.get('data-rpc') || _element.get('href')).trim();
			new Request.JSON({
				url: rpc,
				onRequest: function(){
					this._blimp_content.getElements('.item').hide();
				}.bind(this),
				onSuccess: function(data) {
					this._blimp_content.removeClass('_loading');
					this.set_content(data.content);


				}.bind(this)
			}).get();
		}else{
			this._active_content = this._contents[_element.getAttribute('data-id').toInt()-1].show();
		}
	},

	set_content: function(html_content){
		var self = this;
		var _content = new Element('div', { 'html': html_content, 'class': 'item' });

		this._contents.push(_content);

		this._active_content = _content;
		this._blimp_content.getElements('.item').hide();
		this._blimp_content.adopt(_content);

		Core.add_signup_link(_content.getElement('.reg_blimp'));

		// NCR-4924
		var _tables = _content.getElements('table');

		if (_tables.length > 0) {
			var arrayParsers = ['string', 'title', 'title', 'title', 'title', 'date'];

			_tables.each(function(_table) {
				// for Guest user, the unit column is not being display for available appartments section,
				// so we need to remove the first item in arrayParsers
				if (G && !_table.getElement('th').hasClass('table-th-nosort')) {
					arrayParsers.shift();
				}
				new HtmlTable(_table, {
					sortable: true,
					sortIndex: null,
					zebra: true,
					classZebra: 'y',
					parsers: arrayParsers
				});

				// overide the title parser from HtmlTable.sort
				// the table is being sorted by the value in the title attribute of the td element
				if (HtmlTable && HtmlTable.Parsers) {
					HtmlTable.Parsers.title = {
						match: null,
						convert: function(){
							return this.title.replace(/[^-?^0-9]/g, '').toInt();
						},
						number: true
					};
				}
			});
		}
		var _jump = _content.getElement('.jump_to');
		if (_jump) {
			_jump.addEvent('click', function(e) {
				e.preventDefault();
				e.stopPropagation();

				var section = _jump.getProperty('data-goto');
				if (section) {
					Cookie.write('crBovJumpTo', section);
				}

				var url = _jump.getProperty('href');
				if (url && url !== '') {
					window.location = url;
				}
			});
		}

		var _graph = _content.getElement(this.fcls + '_graph_pricingchart');

		if(!_graph) return;

		new Highstock(_graph, {
			chart: {
				rangeSelector: {
					enabled: false
				}
			},

			tooltip_title: self.blimp._element.getElement('h1').get('text')
		});
	}
});
